import {createAction, props} from "@ngrx/store";

export const setHaveGoodsStore = createAction(
  '[haveGoodsStore] Set Have Good Store',
  props<{ value: boolean }>()
);

